import { MessageSquare } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function ComingSoon() {
  const { t } = useTranslation();

  return (
    <section className="py-20 bg-gray-50 dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-green-600 dark:bg-green-500 rounded-lg shadow-xl p-8 text-center">
          <MessageSquare className="w-16 h-16 text-white mx-auto mb-6" />
          <h2 className="text-3xl font-bold text-white mb-4">
            {t("comingSoon.title")}
          </h2>
          <p className="text-xl text-green-100 mb-6">
            {t("comingSoon.description")}
          </p>
          <div className="inline-block bg-white dark:bg-gray-800 text-green-600 dark:text-green-400 px-6 py-3 rounded-full font-semibold">
            {t("comingSoon.button")}
          </div>
        </div>
      </div>
    </section>
  );
}
